module.exports = __webpack_public_path__ + "static/media/notice.be128c99.mp3";